module.exports = __webpack_public_path__ + "media/images/icon-more-small@3x-f0fb8533bd5bfe4c3f5bb5d20e9a81f7.png";